import * as moment from 'moment';
import { Moment } from 'moment';
import { format, roundToNearestMinutes } from 'date-fns';

export const regexpTime24h: RegExp = /^([01][0-9]|2[0-3]):([0-5][0-9])$/;
export const regexpTimeAmPm: RegExp = /^((1[0-2]|0?[1-9]):([0-5][0-9]) ([AaPp][Mm]))$/;

export function isDate(value: string | Date): value is Date {
  return value instanceof Date;
}

export function isMoment(value: string | Date | Moment | null): value is Moment {
  return moment.isMoment(value);
}

export const convertNumberToStringAddingZeroIfLessThan10 = (num: number | null | undefined): string => {
  if (num === null || num === undefined) {
    return `00`;
  } else if (num < 10) {
    return `0${num}`;
  } else {
    return `${num}`;
  }
};

export const getDateTimeNowAsString = (utc: boolean = true): string => {
  if (utc) {
    const isoStringDateUTC: string = new Date().toISOString();
    const stringDateWithoutTimeZoneInfo: string = `${isoStringDateUTC.substring(0, 10)} ${isoStringDateUTC.substring(
      11,
      19,
    )}`;
    return stringDateWithoutTimeZoneInfo;
  } else {
    return format(new Date(), 'yyyy-MM-dd HH:mm:ss');
  }
};

export const isTime24h = (time: string | null): boolean => {
  if (!time) {
    return false;
  }

  return regexpTime24h.test(time);
};

export const isTimeAmPm = (time: string | null): boolean => {
  if (!time) {
    return false;
  }

  return regexpTimeAmPm.test(time);
};

export const convert24hTimeToAmPm = (time: string | null): string => {
  if (!time) {
    return '';
  }
  const date: Date = new Date(`2024-01-01T${time}:00`);
  return format(date, 'hh:mm aaa').toUpperCase();
};

export const convertAmPmTimeTo24h = (time: string | null): string => {
  if (!time) {
    return '';
  }

  const [time12h, modifier]: string[] = time.split(' ');

  let [hours]: string[] = time12h.split(':');
  const [, minutes]: string[] = time12h.split(':');

  if (hours === '12') {
    hours = '00';
  }

  if (modifier.toUpperCase() === 'PM') {
    hours = `${parseInt(hours, 10) + 12}`;
  }

  if (hours.length === 1) {
    hours = `0${hours}`;
  }

  return `${hours}:${minutes}`;
};

/**
 * Due to how angular-calendar renders event, an event can't start at 23:59:59, otherwise it shows on the previous day.
 * it needs to start at 00:00 on the following day
 * @param dateTime
 */
export const roundToNearestHalfHour = (dateTime: Date): Date => {
  return roundToNearestMinutes(dateTime, { nearestTo: 30, roundingMethod: 'floor' });
};
